import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCookieValue } from "../../../cookieHelper";
import translate from "../../../i18n/translate";
import { IErrorPages } from "../../../interfaces";
import EventIcon from "@material-ui/icons/Event";
import "./ErrorPage.scss";

const ErrorPage: React.FC<IErrorPages> = ({ status }) => {
    let [accessDenied, setAccessDenied] = useState(false);
    let [loadError, setLoadError] = useState(false);
    let [invalidSession, setInvalidSession] = useState(false);
    let [isCourseScheduled, setIsCourseScheduled] = useState(false);
    const supportLink = generateSupportLink()
    

    useEffect(() => {
        logError(status);
    }, [status])

    const logError = (status: number = 404) => {
        if (status === 401) {
            setAccessDenied(true);
        } else if(status >=300 && status <= 399) {
            setInvalidSession(true);
        } else if(status === 400){
            setIsCourseScheduled(true);
        } else if (((status === 406) || (status === 409) || (status === 404)) && !invalidSession) {
            setLoadError(true);
        } 
    }
    function generateSupportLink() {
        const lang = getCookieValue("ulang") === "EN" ? "en-en" : (getCookieValue("ulang") ?? "").toLowerCase();
        return `${process.env["REACT_APP_GE_SUPPORT_URL"]}/${lang}/contact_support`;
      }
      
     
    return (
        <div className="ErrorPage-Container">
            {accessDenied &&
                <div className="ErrorMessage">
                    <div>
                        <img                   
                            src={window.location.origin + "/images/errorPage/error-img.png"}
                            alt="ErrorPage Illustration"
                            title="ErrorPage Illustration"
                        />                        
                    </div>
                    <div>                        
                        <h5>{translate("error_oops")} {translate("error_permission_denied")}</h5>
                        <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                        <p>{translate("error_contact_admin")}</p>
                    </div>
                </div>
            }
            {loadError &&
                <div className="ErrorMessage">
                    <div>
                        <img                   
                            src={window.location.origin + "/images/errorPage/error-img.png"}
                            alt="ErrorPage Illustration"
                            title="ErrorPage Illustration"
                        />
                    </div>
                    <div>                        
                        <h5>{translate("error_sorry")} {translate("error_load")}</h5>
                        <p>{translate("error_clear_cache")}</p>
                        <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                        <p><b>{translate("error_having_trouble")}</b></p>
                        <p>{translate("error_contact")} 
                        <a href={supportLink}> {translate("error_forhelp")} </a> </p>
                    </div>
                </div>
            }

            {invalidSession &&
                <div className="ErrorMessage">
                <div>
                    <img                   
                        src={window.location.origin + "/images/errorPage/error-img.png"}
                        alt="ErrorPage Illustration"
                        title="ErrorPage Illustration"
                    />
                </div>
                <div>
                    <h5>{translate("error_sorry")} {translate("error_load")}</h5>
                    <p>{translate("myschedule_invalid_session")}</p>
                    <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                    <p>{translate("error_contact")} <a href={supportLink}> {translate("error_forhelp")} </a> {translate("error_forhelp")}</p>
                </div>
            </div>
            }
            {isCourseScheduled &&
                <div className="nocourse-box">
                    <div className="nocourse-container">
                        <EventIcon className="nocourse-calendar-icon" fontSize="large"></EventIcon>
                        <div className="nocourse-container-description">{translate("myschedule_nocourse_card_description")}</div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ErrorPage 
